/**
 * Directional drift down gesture
 * @module gestures/effects/driftDown
 */
import { createDriftGesture } from './driftFactory.js';
export default createDriftGesture('down');
